import { storyblokEditable, StoryblokComponent } from "@storyblok/react";
import { customRenderRichText } from "../utils/renderRichText";

const CarouselSlide = ({ blok }) => {
  // Text colors
  const textColorClass = blok.white_text ? "text-white" : "text-black";
  const headingColorClass = blok.white_text ? "text-white" : "text-[#00033E]";
  const bodyTextColor = blok.white_text ? "text-gray-100" : "text-gray-800";

  // Reverse layout toggle
  const layoutClass = blok.reverse_layout ? "md:flex-row-reverse" : "md:flex-row";

  // Grid layout
  const featureCount = blok.features?.length || 0;
  const gridColsClass =
    featureCount === 1
      ? "grid-cols-1 justify-items-center"
      : featureCount === 2
      ? "grid-cols-2 justify-items-center"
      : "grid-cols-3";

  // Background color for the IMAGE section
  const imageBgClassMap = {
    dark_blue: "bg-[#00033E]",
    light_blue: "bg-[#1371DC]",
    white: "bg-white",
  };

  const imageBgClass =
    imageBgClassMap[blok.image_background_color] || "bg-white";

  return (
    <div
      {...storyblokEditable(blok)}
      className={`flex flex-col ${layoutClass} w-full h-auto md:h-[600px] md:max-h-[600px] md:overflow-hidden`}
    >
      {/* Text Section */}
      <div
        className={`flex flex-col justify-center md:w-1/2 px-8 md:px-20 py-10 ${textColorClass}`}
      >
        {blok.heading && (
          <h2
            className={`text-3xl md:text-4xl font-bold mb-6 leading-tight ${headingColorClass}`}
          >
            {blok.heading}
          </h2>
        )}

        {blok.body && (
          <div
            className={`text-base md:text-lg opacity-90 leading-relaxed max-w-[600px] ${bodyTextColor}`}
          >
            {typeof blok.body === "string"
              ? blok.body
              : customRenderRichText(blok.body)}
          </div>
        )}
      </div>

      {/* Image and Features */}
      <div
        className={`flex flex-col justify-center items-center md:w-1/2 ${imageBgClass} py-10 px-8 relative`}
      >
        {blok.title && (
          <h3 className="text-3xl font-bold text-[#00033E] mb-6 text-center">
            {blok.title}
          </h3>
        )}

        {/* Image fill toggle */}
        {blok.image?.filename && (
          <div
            className={`flex justify-center items-center w-full mb-8
              ${
                blok.image_fill
                  ? // Mobile: taller fixed image area; Desktop: fill panel
                    "relative h-[400px] md:h-full md:absolute md:inset-0 md:mb-0 md:px-0 md:py-0"
                  : // Mobile: same taller height; Desktop: 400px tall
                    "h-[400px] md:h-[400px]"
              }
            `}
          >
            <img
              src={blok.image.filename}
              alt={blok.image.alt || ""}
              className={
                blok.image_fill
                  ? // Mobile full image visible in taller area Desktop cover
                    "w-full h-full object-contain md:object-cover"
                  : // keep image contained within taller box
                    "w-auto h-full object-contain mx-auto"
              }
            />
          </div>
        )}

        {/* Feature Grid */}
        {!blok.image_fill && blok.features && blok.features.length > 0 && (
          <div className={`grid gap-6 w-full ${gridColsClass}`}>
            {blok.features.map((feature) => (
              <StoryblokComponent blok={feature} key={feature._uid} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default CarouselSlide;
